import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import { Box, Collapse, List, ListItemButton, ListItemIcon, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useStyles } from '../styles';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import routes from '../../../Utils/routes';

interface mobileSideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const MobileSideNav: React.FunctionComponent<mobileSideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [openPeople, setOpenPeople] = useState(false);
  const {
    state: { user },
  } = useContext(AuthContext);

  const handlePeopleClick = () => {
    setOpenPeople(!openPeople);
  };

  const roles = user?.contactRoles || [];
  const isInvestor = ['Strategic Investor', 'Passive Investor'].some((role) => roles?.includes(role));
  const isJuryMember = roles?.includes('Jury Member');
  const hasAllRoles = isInvestor && isJuryMember;

  // const showMenuItem = (roleNeeded: boolean) => roleNeeded || hasAllRoles;
  const showMenuItem = (roleNeeded: boolean) => roleNeeded || hasAllRoles || true;
  console.log(showMenuItem(isJuryMember), 'hello');
  const sideNavContents = [
    {
      icon: (isActive: boolean) => <PermIdentityOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'My Profile',
      link: routes.profile,
      name: 'my profile',
    },
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <HomeOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <AnalyticsOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'My portfolio',
      link: routes.myPortfolio,
      name: 'portfolio',
    },
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <GroupsOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'TS Global Portfolio',
      link: routes.startups,
      name: 'TS Global Portfolio',
    },
  
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <AutoAwesomeIcon className={classes.menuListItemIcon} />,
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <LightbulbOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'COE',
      link: routes.coe,
      name: 'coe',
    },
    showMenuItem(isInvestor) && {
      icon: (isActive: boolean) => <ContactSupportOutlinedIcon className={classes.menuListItemIcon} />,
      label: 'Support',
      link: routes.support,
      name: 'support',
    },
    // showMenuItem(isJuryMember) && {
    //   icon: (isActive: boolean) => <SpaceDashboardOutlinedIcon className={classes.menuListItemIcon} />,
    //   label: 'GIC Portal',
    //   link: routes.juryPortal,
    //   name: 'jury',
    // },
  ].filter(Boolean);

  const isActive = (link: string) => pathname.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some((nestedItem) => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items, index) => {
        if (items.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          return (
            <div key={index}>
              <ListItemButton onClick={handlePeopleClick} sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }} className={`${classes.menuListItemButton}`}>
                <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(items?.nestedItems.some((nestedItem: any) => isActive(nestedItem.link)))}</ListItemIcon>
                <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography className={`${classes.menuListItemText}`}>{items.label}</Typography>
                  {openPeople ? <ExpandLess sx={{ color: '#333' }} /> : <ExpandMore sx={{ color: '#333' }} />}
                </Box>
              </ListItemButton>
              <Collapse in={openPeople} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items?.nestedItems.map((nestedItem: any, nestedIndex: any) => (
                    <ListItemButton key={nestedIndex} onClick={() => handleListClick(nestedItem?.link, nestedIndex)} className={`${classes.menuListItemButton}`}>
                      <Box sx={{ ml: 1.5, display: 'flex', alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem?.icon(isActive(nestedItem?.link))}</ListItemIcon>
                        <Typography className={`${classes.menuListItemText}`}>{nestedItem?.label}</Typography>
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => {
                handleListClick(items?.link, index);
              }}
              sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
              className={`${classes.menuListItemButton}`}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>{items?.icon(isActive(items?.link))}</ListItemIcon>
              <Typography className={`${classes.menuListItemText}`}>{items?.label}</Typography>
            </ListItemButton>
          );
        }
      })}
    </>
  );
};

export default MobileSideNav;
